import template from "./item_holds.html";
import controller from "./item_holds.controller";
import "./item_holds.scss";

let branchManagementItemHoldsComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementItemHoldsComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/item_holds/item_holds.component.js